import { render } from "./AddInvoiceTheme.vue?vue&type=template&id=4245f56a&scoped=true"
import script from "./AddInvoiceTheme.vue?vue&type=script&lang=js"
export * from "./AddInvoiceTheme.vue?vue&type=script&lang=js"

import "./AddInvoiceTheme.vue?vue&type=style&index=0&id=4245f56a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4245f56a"]])

export default __exports__